<template>
  <div>
    <v-btn
      v-if="!isPhone"
      color="green"
      class=""
      icon
      x-large
      @click="dialog = true"
      ><v-icon>mdi-plus-box</v-icon></v-btn
    >
    <v-dialog v-model="dialog" width="600" persistent scrollable>
      <v-card>
        <ModalHeader
          title="Add Account"
          icon="mdi-account-plus"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-form ref="form">
            <div class="section-label">
              <v-icon x-small>mdi-account</v-icon> Customer Details
            </div>
            <v-text-field
              label="Customer Name"
              prepend-inner-icon="mdi-account-circle-outline"
              v-model="form.customer_name"
              outlined
              dense
              class="mb-2"
            ></v-text-field>
            <v-text-field
              label="Customer Contact Number"
              prepend-inner-icon="mdi-phone-outline"
              v-model="form.customer_contact_no"
              prefix="+63"
              :rules="contactNumberRules"
              hint="Enter one PH mobile number only, e.g. 9123456789"
              persistent-hint
              outlined
              dense
              class="mb-2"
            ></v-text-field>
            <v-text-field
              label="Customer TIN"
              prepend-inner-icon="mdi-form-textbox-password"
              v-model="form.tin"
              outlined
              dense
              class="mb-2"
            ></v-text-field>
            <v-text-field
              label="Other Contact Platform"
              prepend-inner-icon="mdi-facebook-messenger"
              prefix="messenger via -"
              v-model="form.other_contact_platform"
              outlined
              dense
              class="mb-2"
            ></v-text-field>
            <address-picker
              Heading="Customer Address"
              @extract_address_value="extract"
            />
            <div class="section-label mt-3">
              <v-icon x-small>mdi-cloud-question-outline</v-icon> Attribution
            </div>
            <v-select
              :items="where_did_you_find_us"
              label="Where did you find us?"
              prepend-inner-icon="mdi-cloud-question-outline"
              v-model="form.where_did_you_find_us"
              outlined
              dense
              hide-details
              class="mb-2"
            ></v-select>
            <v-select
              prepend-inner-icon="mdi-account"
              v-model="form.is_government"
              label="Is this a Government Entity?"
              :items="isGovernment"
              item-text="text"
              item-value="value"
              outlined
              dense
              hide-details
            ></v-select>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <p class="caption grey--text mb-0">addCustomerModal.vue</p>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" text>Close</v-btn>
          <v-btn @click="reset" text>Reset</v-btn>
          <v-btn @click="submit" color="primary" depressed :loading="loading">
            <v-icon left small>mdi-check</v-icon>Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import AddressPicker from "@/components/addressPicker.vue";
export default {
  components: { AddressPicker },
  data() {
    return {
      dialog: false,
      loading: false,
      isGovernment: [
        { text: "Yes", value: 1 },
        { text: "No", value: 0 },
      ],
      form: {
        customer_name: "",
        customer_contact_no: "",
        other_contact_platform: "",
        customer_municipality: "",
        customer_barangay: "",
        customer_purok: "",
        where_did_you_find_us: "",
        tin: "000-000-000",
        is_government: 0,
      },
      where_did_you_find_us: [
        "Brochuers and Flyers",
        "Facebook",
        "Radio",
        "Referal",
      ],
      contactNumberRules: [
        (v) => !!v || "Contact number is required",
        (v) =>
          /^\d{10}$/.test((v || "").replace(/[\s-]/g, "")) ||
          "Enter one 10-digit PH number only (e.g. 9123456789)",
      ],
    };
  },
  methods: {
    ...mapActions({
      add_customer: "customer/add_customer",
      set_notification: "notification/set_notification",
    }),

    extract(data) {
      this.form.customer_municipality = data[0];
      this.form.customer_barangay = data[1];
      this.form.customer_purok = data[2];
      console.log(this.form);
    },
    async submit() {
      this.loading = true;
      if (
        !this.$refs.form.validate() ||
        this.form.customer_name == "" ||
        this.form.customer_municipality == "" ||
        this.form.customer_contact_no == ""
      ) {
        this.loading = false;
        return this.set_notification({
          message: "Please check all fields",
          type: "error",
        });
      }

      try {
        await this.add_customer(this.form);
        this.loading = false;
        return this.set_notification({
          message: "You have successfully inserted a new customer!",
          type: "success",
        });
      } catch (e) {
        this.loading = false;
        return this.set_notification({
          message: e,
          type: "error",
        });
      }
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>
